import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { hasElements } from "utils/arrays";
import { useNotifications } from "./Notifications";

function Indicator({id, className, identity, getter }) {
    const [notificationsLabel, setNotificationsLabel] = useState();
    const notifications = useNotifications(`indicator-${id}`, false);
    useEffect(() => {
        if (identity && notifications) {
            const notificationsForIdentity = getter ? getter() : notifications[identity];
            const notificationsLabel =
                notificationsForIdentity && (notificationsForIdentity.length > 9 ? "9+" : notificationsForIdentity.length);
            setNotificationsLabel(notificationsLabel);
        } else if (notifications && identity === null) {
            const totalNotifications = Object.values(notifications).reduce((acc, arr) => acc + (hasElements(arr) ? arr.length : 0), 0);
            const notificationsLabel = totalNotifications && (totalNotifications > 9 ? "9+" : totalNotifications);
            setNotificationsLabel(notificationsLabel);
        }

        return () => {
            setNotificationsLabel(undefined);
        };
    }, [identity, notifications, getter]);

    if (!notificationsLabel) {
        return null;
    }

    return <mark className={clsx("notifications-badge tada", className)}>{notificationsLabel}</mark>;
}

export default Indicator;
